/*
 *
 * Copyright 2022, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */
import './WrcDownload.css';
import React from 'react';
import {Button, HTMLSelect} from "@blueprintjs/core";
import {Card, Elevation} from "@blueprintjs/core";
import { WrcCardHeader } from "./WrcCardHeader";
import {Intent} from "@blueprintjs/core/lib/esm/index";
import {IconNames} from "@blueprintjs/icons";
import { Toaster } from "@blueprintjs/core/lib/esm/index";
import { WrcServer } from "./WrcServer.js";
import { WrcGlobal } from './WrcGlobal';

export class WrcDownload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected_download: 'Choose an option...',
            is_loaded: false,
            display: false,
            downloads: []
        };
    }

    componentDidMount() {
        let permissions = this.props.downloads.map((download) => {
            let level = download.permissions_env.split('_')
            let obj = {
                "env": download.permissions_env, 
                "label": download.label, 
                "level": level[level.length-1].toLowerCase()
            }
            return obj
        })

        WrcServer.post('get-download-permissions',
        {"permissions": permissions},
        (content) => this.checkPermissions(content, permissions)
        );
    }

    checkPermissions = (content, permissions) => {
        let should_display = true;
        let authorized_downloads = [];
        for (const [key, value] of Object.entries(content)) {
            let permission = permissions.filter((p) => {return p.label === key})[0]
            switch (permission.level) {
                case 'users':
                    if (value.includes('*ALL*') || value.includes(this.props.username)) {
                        if (!authorized_downloads.includes(permission.label)) {
                            authorized_downloads.push(permission.label)
                        }
                    }
                    break;
                case 'groups':
                    value.forEach((group) => {
                        if (group === '*ALL*' || this.props.ad_groups.includes(group)) {
                            if (!authorized_downloads.includes(permission.label)) {
                                authorized_downloads.push(permission.label)
                            }
                        }
                    });
                    break;
            }
        }
        // no permissions for anything so don't show the component
        if (authorized_downloads.length === 0) {
            should_display = false;
        }
        // get downloads that they do have permissions to
        let display_downloads = this.props.downloads.filter((download) => {
            return authorized_downloads.includes(download.label)
        })
        this.setState({
            is_loaded: true,
            display: should_display,
            downloads: display_downloads
        });
    }

    downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType });

        const a = document.createElement("a");
        a.download = fileName;
        a.href = window.URL.createObjectURL(blob);
        const clickEvt = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        a.dispatchEvent(clickEvt);
        a.remove();
    };

    exportCSV = (content) => {
        // check for a custom filename. defaults to the label
        let selected_download = this.state.downloads.filter((download) => {
            return download.label === this.state.selected_download
        })[0]
        let filename = this.state.selected_download + ".csv"
        // custom filename is set
        if (selected_download['file_name']) {
            filename = selected_download['file_name']
            // replace current_date tag
            filename = filename.replace('{current_date}', WrcGlobal.get_db_today())
            //... add more custom tags here
            if (filename.slice(-4) !== '.csv') {
                filename += ".csv"
            }
        }
        this.downloadFile({
            data: content,
            fileName: filename,
            fileType: "text/csv",
        });
    }   
    
    getDownloadData = () => { 
        if (this.state.selected_download === 'Choose an option...') {
            Toaster.create().show({ message: 'You must select a downloadable from the menu.', intent: Intent.WARNING });
            return;
        }
        let download = this.state.downloads.filter((download) => download.label === this.state.selected_download)
        WrcServer.post('get-download-data',
            {
                "download": download,
                "source": "registry"
            },
            (content) => this.exportCSV(content)
        );
    }

    handleSelect = (e) => {
        this.setState({
            selected_download: e.target.value
        });
    }

    render() {
        if (this.state.display) {
            if (this.state.is_loaded) {
                let dropdown_options = ["Choose an option..."].concat(this.state.downloads.map((elem) => (elem.label)))
                let download_dropdown = (
                <div style={{padding: '5px', margin: '5px'}}>
                    <HTMLSelect
                        value={this.state.selected_download}
                        onChange={this.handleSelect}
                        options={dropdown_options}
                    />
                </div>
                );
                let download_button = (
                <div style={{padding: '5px', margin: '5px'}}>
                    <Button
                        icon={IconNames.SEARCH}
                        intent={Intent.PRIMARY}
                        text={'Download Selected Data'}
                        onClick={() => this.getDownloadData()} />
                </div>
                );
                return (
                    <div className="app-download-h left">
                        <div className="app-download-children-h">
                            <Card interactive={false} elevation={Elevation.ZERO} className='wd-card-m-top'>
                                <WrcCardHeader small={true} title={'Data Downloads'} />
                                {download_dropdown}
                                {download_button}
                            </Card>
                        </div>
                    </div>
                );
            } else {
                return (<div>Loading...</div>);
            } 
        } else {
            return (<div></div>)
        }
    }
}